import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero } from '../components/bits';
import { useLead } from '../components/LeadModal';
import { BIZ_PHASES } from '../content/data';

export default function BusinessCreator() {
  const { open } = useLead();
  return (
    <div data-testid="business-creator-page">
    <SEO title="9-Month Business & Creator Track" description="Turn digital capability into audience, clients and income." />
      <PageHero
        ck="business"
        tag="9-Month Business & Creator Track"
        lines={<>Turn Digital Capability Into <span className="font-serif italic font-normal text-electric">Audience, Clients and Income.</span></>}
        intro="A focused programme for learners interested in digital business, content, marketing, sales, audience growth, freelancing and entrepreneurship."
      >
        <ArrowBtn onClick={() => open('Student Programmes')} variant="primary" testId="business-cta-apply">Apply for Business & Creator Track</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap space-y-8">
          {BIZ_PHASES.map((p, i) => (
            <Reveal key={p.phase} delay={i * 0.05}>
              <div data-testid={`biz-phase-${i}`} className="grid gap-8 rounded-3xl border border-navy/10 bg-white p-8 sm:p-10 lg:grid-cols-[280px_1fr]">
                <div>
                  <span className="overline !text-[10px] text-electric">{p.phase}</span>
                  <h2 className="text-h3 mt-3 font-semibold">{p.title}</h2>
                </div>
                <ul className="grid content-start gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
                  {p.items.map((x) => (
                    <li key={x} className="flex items-center gap-2.5 rounded-xl bg-paper px-4 py-3 text-sm font-medium text-navy/80">
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-electric" />{x}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-grid-dark bg-navy py-20 text-white sm:py-28">
        <div className="wrap grid items-center gap-10 lg:grid-cols-2">
          <div>
            <SectionTag dark>The Outcome</SectionTag>
            <Reveal delay={0.05}>
              <h2 className="text-h2 mt-5 font-semibold">Leave With a <span className="font-serif italic font-normal text-gold">Monetizable Presence.</span></h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-base leading-relaxed text-white/70 sm:text-lg">
              Build a monetizable digital presence, develop practical campaign experience, create a portfolio of work and move toward independent commercial activity.
            </p>
            <div className="mt-8"><ArrowBtn onClick={() => open('Student Programmes')} variant="gold" testId="business-cta-apply-bottom">Apply for Business & Creator Track</ArrowBtn></div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
